export default __webpack_public_path__ + "static/media/milestone 77 badge.ac412d24.svg";